export const ORGANIZATION_USER_STATUS = {
  ACTIVE: "Active",
  PENDING: "Pending",
  INACTIVE: "Inactive",
};

export const ORGANIZATION_USER_ROLE = {
  ACCOUNT_HOLDER: "Account Holder",
  ADMIN: "Admin",
  COLLABORATOR: "Collaborator",
  VIEWER: "Viewer",
};
